import React from "react";

/**
 * Shared search input for menu / combos / deals (styled like .menu-searchbar).
 */
export default function GlobalOrderingSearchBar({
    value,
    onChange,
    onClear,
    onSubmit,
    placeholder = "Search menu, combos, and deals",
    ariaLabel = "Search menu, combos, and deals",
    className = "",
}) {
    const handleSubmit = (event) => {
        event.preventDefault();
        const next = typeof value === "string" ? value.trim() : "";
        if (typeof onSubmit === "function") {
            onSubmit(next);
        }
    };

    return (
        <form
            className={`menu-searchbar global-ordering-searchbar ${className}`.trim()}
            onSubmit={handleSubmit}
            role="search"
        >
            <div className="menu-searchbar__icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M21 21L16.65 16.65"
                        stroke="#111"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18Z"
                        stroke="#111"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </div>
            <input
                className="menu-searchbar__input"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                aria-label={ariaLabel}
                type="search"
                inputMode="search"
                enterKeyHint="search"
                autoComplete="off"
            />
            {value ? (
                <button
                    type="button"
                    className="menu-searchbar__clear"
                    onClick={onClear}
                    aria-label="Clear search"
                >
                    ×
                </button>
            ) : null}
        </form>
    );
}
